import { useMemo, useState } from 'react';

export function useSortable(itens, campoInicial) {
  const [campo, setCampo] = useState(campoInicial);
  const [asc, setAsc] = useState(true);

  const sorted = useMemo(() => {
    if (!campo) return itens;
    return [...itens].sort((a, b) => {
      const va = a[campo];
      const vb = b[campo];
      if (va == null) return 1;
      if (vb == null) return -1;
      if (typeof va === 'number' && typeof vb === 'number') return asc ? va - vb : vb - va;
      return asc ? String(va).localeCompare(String(vb), 'pt-BR') : String(vb).localeCompare(String(va), 'pt-BR');
    });
  }, [itens, campo, asc]);

  const toggle = (novoCampo) => {
    if (novoCampo === campo) setAsc((a) => !a);
    else {
      setCampo(novoCampo);
      setAsc(true);
    }
  };

  const Th = ({ campo: c, children, className = '' }) => (
    <th role="button" className={`user-select-none ${className}`} onClick={() => toggle(c)}>
      {children}
      {campo === c && <i className={`bi ms-1 ${asc ? 'bi-caret-up-fill' : 'bi-caret-down-fill'}`} />}
    </th>
  );

  return { sorted, Th };
}
